/**
 * This is used to extract the data contained in the feedbackMode string.
 * The valid values are: NoFeedback, Feedback, FeedbackAndCorrectSolution.
 */
var createGameSettings = function (feedbackMode) {
	var settings = {};
	settings.shouldDisplayWhetherChosenAnswerIsCorrect = (/^Feedback/).test(feedbackMode);
	settings.shouldDisplayCorrectSolution = feedbackMode == 'FeedbackAndCorrectSolution';
	return settings;
}